import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";
import Lang from "../../lib/lang";
import * as utils from "../../assets/utils";
import Td_Sel from "../../lib/ui/td_sel";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Bo_Cat extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = {};
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.kaa = [];
    this.state.kro = {};
    this.state.aa = [];
      this.state.cols = {};
      this.state.wnds = {};
      this.state.msg = {};
      this.state.sortid = "";
      this.state.sortdir = 1;

      this.selitems = [
          {fkn: 'open', text: 'ÖPPNA'},
          {fkn: 'stat', text: 'STATUS'}
      ];
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.cats();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 250;
        css.overflow = "auto";
        return css;
    }
    th_style(id) {
        var css = {};
        css.cursor = "pointer";
        if(id == this.state.sortid) css.color = "#080";
        return css;
    }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }
    cat_edit(row) {
        var self = this;
        var wnds = {};
        wnds.catedit = true;
        wnds.cat = row;
        this.setState({wnds: wnds});
    }

  cats() {
    var self = this;
    var prm = {};
    prm.req = "ta.ta_def.cat_list";
    //prm.avd = this.state.avd;
    //prm.fplu = datum;
    //prm.tplu = datum;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({kaa: ret.rca });
        self.syncTb("catTable");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
    syncTb(tb){
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
            tdElements = tbel.getElementsByTagName('td');

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
                width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
    th_icon(typ) {
        var cls = "";
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;
        if(sortid == typ)
        {
            if(sortdir) cls = "fa fa-caret-up";
            else cls = "fa fa-caret-down";
        }
        return cls;
    }
    tb_sort(typ) {
        var self = this;
        //var rvs = self.state.rvs;
        var kaa = self.state.kaa;
        var sz = this.state.sz_val;
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;

        if(sortid != typ) sortdir = 0;
        else {
            if(sortdir) sortdir = 0;
            else sortdir = 1;
        }

        if(sortdir) kaa.sort((a,b) => (a[typ] > b[typ]) ? 1 : ((b[typ] > a[typ]) ? -1 : 0));
        else kaa.sort((a,b) => (a[typ] < b[typ]) ? 1 : ((b[typ] < a[typ]) ? -1 : 0));
        self.setState({ kaa: kaa, sortid: typ, sortdir: sortdir });
    }
    sel_row_fkn(row, sel) {
        if(sel.fkn == "open") {
            this.cat_edit(row);
        }
    }

  render() {
    return (
    <div className="web-app">

    <div className="flex-row flex-space-between">
        <div className="label_h03">KATEGORIER</div>
        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.syncCols("kidTable") } aria-label="System" >
            Visa
        </button>
    </div>
    <div className="divider"></div>

        <div id="catTable">
            <table id="coHead" className="table table-bordered table-hover tb" style={{marginBottom: "0px"}}>
                <thead>
                <tr>
                    <th style={ this.th_style("kategori") } onClick={() => this.tb_sort("kategori") }>Kategori <i className={ this.th_icon("kategori") }></i></th>
                    <th style={ this.th_style("namn") } onClick={() => this.tb_sort("namn") }>Text <i className={ this.th_icon("namn") }></i></th>
                    <th style={ this.th_style("kosttim") } onClick={() => this.tb_sort("kosttim") }>Kosttim <i className={ this.th_icon("kosttim") }></i></th>
                    <th style={ this.th_style("kostenh") } onClick={() => this.tb_sort("kostenh") }>Kostenhet <i className={ this.th_icon("kostenh") }></i></th>
                    <th style={ this.th_style("OBart") } onClick={() => this.tb_sort("OBart") }>OB Art <i className={ this.th_icon("OBart") }></i></th>
                    <th style={ this.th_style("OBnatt") } onClick={() => this.tb_sort("OBnatt") }>OB Natt <i className={ this.th_icon("OBnatt") }></i></th>
                    <th></th>
                </tr>
                </thead>
            </table>
            <div style={ this.tb_style() }>
                <table id="coTable" className="table table-bordered table-hover tb">
                    <tbody>
                    { this.state.kaa.map((row, key) =>
                        <tr key={key} onDoubleClick={() => this.cat_edit(row)}>
                            <td>{ row.kategori }</td>
                            <td>{ utils.toLang( row.namn ) }</td>
                            <td>{ utils.toNum( row.kosttim ) }</td>
                            <td>{ row.kostenh }</td>
                            <td>{ row.OBart }</td>
                            <td>{ row.OBnatt }</td>
                            <td>
                                <Td_Sel items={ this.selitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </div>
   </div>
  );
}
}
export default Bo_Cat;
